<div class="container dd-checkout">
  @if (isEmpty()) {
    <p class="cart-empty woocommerce-info">Your cart is currently empty.</p>
    <p class="return-to-shop">
      <a class="button wc-backward" routerLink="/shop">Return to shop</a>
    </p>
  } @else {
    <form class="checkout woocommerce-checkout" [formGroup]="contactForm" (ngSubmit)="pay()" novalidate>
      <div class="col2-set" id="customer_details">
        <div class="col-1">
          <div class="woocommerce-billing-fields">
            <h3>Billing details</h3>
            <p class="form-row form-row-first">
              <label for="billing_first_name">First name <abbr class="required" title="required">*</abbr></label>
              <input id="billing_first_name" type="text" formControlName="firstName" autocomplete="given-name" />
            </p>
            <p class="form-row form-row-last">
              <label for="billing_last_name">Last name <abbr class="required" title="required">*</abbr></label>
              <input id="billing_last_name" type="text" formControlName="lastName" autocomplete="family-name" />
            </p>
            <p class="form-row form-row-wide">
              <label for="billing_phone">Phone <abbr class="required" title="required">*</abbr></label>
              <input id="billing_phone" type="tel" formControlName="phone" autocomplete="tel" />
            </p>
            <p class="form-row form-row-wide">
              <label for="billing_email">Email address <abbr class="required" title="required">*</abbr></label>
              <input id="billing_email" type="email" formControlName="email" autocomplete="email" />
            </p>
          </div>
        </div>
        <div class="col-2">
          <h3 id="order_review_heading">Your order</h3>
          <div id="order_review" class="woocommerce-checkout-review-order">
            <table class="shop_table woocommerce-checkout-review-order-table">
              <thead>
                <tr>
                  <th class="product-name">Product</th>
                  <th class="product-total">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                @for (line of items(); track line.id) {
                  <tr class="cart_item">
                    <td class="product-name">
                      {{ line.name }}
                      <strong class="product-quantity">&times;&nbsp;{{ line.quantity }}</strong>
                    </td>
                    <td class="product-total">
                      <span class="woocommerce-Price-amount amount">
                        <span class="woocommerce-Price-currencySymbol">$</span
                        >{{ lineTotal(line) | number: '1.2-2' }}
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <tr class="cart-subtotal">
                  <th>Subtotal</th>
                  <td>
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">$</span
                      >{{ subtotal() | number: '1.2-2' }}
                    </span>
                  </td>
                </tr>
                <tr class="tax-total">
                  <th>Tax ({{ taxRatePercent() }}%)</th>
                  <td>
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">$</span
                      >{{ tax() | number: '1.2-2' }}
                    </span>
                  </td>
                </tr>
                <tr class="order-total">
                  <th>Total</th>
                  <td>
                    <strong>
                      <span class="woocommerce-Price-amount amount">
                        <span class="woocommerce-Price-currencySymbol">$</span
                        >{{ total() | number: '1.2-2' }}
                      </span>
                    </strong>
                  </td>
                </tr>
              </tfoot>
            </table>

            @if (priceChanges().length > 0) {
              <div class="woocommerce-info dd-checkout__price-warning">
                <strong>Some prices have changed:</strong>
                <ul>
                  @for (change of priceChanges(); track change.name) {
                    <li>
                      <strong>{{ change.name }}</strong>:
                      <del>${{ change.oldPrice | number: '1.2-2' }}</del>
                      → <strong>${{ change.newPrice | number: '1.2-2' }}</strong>
                    </li>
                  }
                </ul>
                <p>Do you want to continue with the updated prices?</p>
                <button type="button" class="button alt" (click)="confirmPriceChanges()">Continue</button>
                <button type="button" class="button" (click)="dismissPriceChanges()" style="margin-left: 0.5rem;">Cancel</button>
              </div>
            }

            @if (error()) {
              <p class="woocommerce-error dd-checkout__error">{{ error() }}</p>
            }

            @if (priceChanges().length === 0) {
              <div class="form-row place-order">
                <button type="submit" class="button alt" id="place_order" [disabled]="submitting()">
                  {{ submitting() ? 'Processing…' : 'Place order' }}
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  }
</div>
